// VITE_YEATI_API_URL already ends with /api/admin.
const BASE = "/direct_debit";

export const DIRECT_DEBIT_ENDPOINTS = {
  SITUATION: BASE,
  CONFIRMATION_CODE: `${BASE}/confirmation_code`,
  BANK_ACCOUNT_REQUESTS: `${BASE}/bank_account_requests`,
  BANK_ACCOUNT_REQUEST: (id: number) => `${BASE}/bank_account_requests/${id}`,
  PAYMENT_REQUESTS: `${BASE}/payment_requests`,
  PAYMENT_REQUEST: (id: number) => `${BASE}/payment_requests/${id}`,
} as const;
